import { ThemeOverride } from '@chakra-ui/react';

const themeOverrides: ThemeOverride = {
  breakpoints: {
    base: '0em',
    sm: '30em',
    md: '48em',
    lg: '62em',
    xl: '80em',
    '2xl': '96em',
    '3xl': '110em',
  },
  styles: {
    global: {
      html: {
        boxSizing: 'border-box',
      },
      '*, *:before, *:after': {
        boxSizing: 'inherit',
      },
      body: {
        backgroundColor: 'gray.100',
      },
      button: {
        cursor: 'pointer',
      },
    },
  },
  colors: {
    gray: {
      // these are Chakras greys, each destaturated by 50
      50: '#f9f9f9',
      100: '#f2f2f2',
      200: '#e9e9e9',
      300: '#d5d5d5',
      400: '#b0b0b0',
      500: '#838383',
      600: '#595959',
      700: '#3a3a3a',
      800: '#232323',
      900: '#1d1d1d',
    },
    success: {
      50: '#EAFAEF',
      100: '#C5F2D2',
      200: '#9FEAB5',
      300: '#7AE197',
      400: '#54D97A',
      500: '#24A148',
      600: '#25A74B',
      700: '#1C7D38',
      800: '#135325',
      900: '#092A13',
    },
    warning: {
      50: '#FFF0E5',
      100: '#FFD5B8',
      200: '#FFBA8A',
      300: '#FF9F5C',
      400: '#FF842E',
      500: '#FF832C',
      600: '#CC5400',
      700: '#993F00',
      800: '#662A00',
      900: '#331500',
    },
    error: {
      50: '#FCE9EA',
      100: '#F6C1C3',
      200: '#F0989D',
      300: '#EB7076',
      400: '#E54850',
      500: '#D91F28',
      600: '#B31921',
      700: '#861319',
      800: '#590D10',
      900: '#2D0608',
    },
    darkBlue: {
      50: '#F0F1F5',
      100: '#D4D9E3',
      200: '#B8C1D1',
      300: '#9CA8BF',
      400: '#8090AD',
      500: '#64789B',
      600: '#50607C',
      700: '#3C485D',
      800: '#28303E',
      900: '#14181F',
    },
    the: {
      red: '#e40327',
      purple: '#b70d7f',
      blue: '#1b60ab',
      redViolet: '#DE1B7C',
      electricViolet: '#6933F7',
      redOrange: '#FE4537',
    },
    sdg: {
      borderGrey: '#EBEBEB',
      analysisText: '#343E50',
      lightGrey: '#B7B1B1',
      darkGrey: '#565252',
      darkSlateBlue: '#34495e',
      statValueText: '#565252',
      statLabelHelpText: '#565252',
      disabledText: '#B7B1B1',
      tickfont: '#B7B1B1',
      boxPlotLevel2: '#565252',
      boxPlotLevel3: '#8C8C8C',
      pageBgcolour: '#e8ecee',
      filterHelpText: '#1169a3',
      tooltipLink: '#FF842E',
    },
  },
  fonts: {
    body: "'Open Sans', sans-serif",
  },
  fontSizes: {
    xxs: '0.625rem',
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.75rem',
    '4xl': '2rem',
    '5xl': '2.25rem',
    '6xl': '2.5rem',
    '7xl': '2.75rem',
    '8xl': '3rem',
    '9xl': '3.25rem',
    sdg: {
      '3xl': '1.8rem',
    },
  },
  components: {
    Checkbox: {
      defaultProps: {
        colorScheme: 'yellow',
      },
    },
    Select: {
      sizes: {
        sm: {
          field: {
            borderRadius: 'md',
          },
          addon: {
            borderRadius: 'md',
          },
        },
      },
    },
  },
};

export default themeOverrides;
